module.exports = __webpack_public_path__ + "static/scene_bg-899ba22b38a5aa1d9110e86d32082248.jpg";